import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LoteProduto } from 'src/app/models/lote-produto';
import { Produto } from 'src/app/models/produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { LoteProdutoService } from 'src/app/services/lote-produto.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { PedidosLoteModalComponent } from '../pedidos-lote-modal/pedidos-lote-modal.component';
import { GlobalService } from 'src/app/services/global.service';
import { HistoricoDoPrecoModalComponent } from '../historico-do-preco-modal/historico-do-preco-modal.component';
import { PremissasSistema } from 'src/app/models/premissas-sistema';

// jquery
declare const $: any;

@Component({
  selector: 'app-estoque-produto-modal',
  templateUrl: './estoque-produto-modal.component.html',
  styleUrls: ['./estoque-produto-modal.component.scss']
})
export class EstoqueProdutoModalComponent implements OnInit, OnDestroy {

  // variáveis
  // produtos: Produto[] = [];
  lotes: LoteProduto[] = [];

  verExcel = false;

  public config: PerfectScrollbarConfigInterface = {};

  vendaProgramada = false;

  produto: Produto = new Produto();

  totalQtd = 0;
  totalEstoque = 0;
  totalReservado = 0;
  totalFaturado = 0;

  idFornecedor;

  mostrarCodErp = false;

  reservaManual = false;

  premissasSistema = new PremissasSistema();

  constructor(private loteProdutoService: LoteProdutoService, public utilitarioService: UtilitarioService, private premissasService: PremissasService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private globalService: GlobalService,
    public dialogRef: MatDialogRef<EstoqueProdutoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) { }

  async ngOnInit() {

    await this.buscarPremissasSistema();

    this.idFornecedor = this.data.idFornecedor;

    this.verExcel = (await this.globalService.consultaUsuario()).verExcel;

    this.buscarMostrarCodErp();

    this.produto = this.data.produto;

    await this.buscarVendaProgramada();
    await this.buscarReservaManual();

    if (this.vendaProgramada) {
      this.buscarEstoque();
    }
  }

  async buscarReservaManual() {
    try {
      this.carregandoService.mostra('buscarReservaManuak');
      this.reservaManual = (await this.premissasService.consultarUsarReservaManual().toPromise()).valor;
      this.carregandoService.esconde('buscarReservaManuak');
    } catch (erro) {
      this.carregandoService.esconde('buscarReservaManuak');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = (await this.premissasService.consultarPremissasSistema().toPromise());
      this.carregandoService.esconde('buscarPremissasSistema');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissasSistema');
      this.notificacaoService.erro(erro);
    }
  }

  buscarEstoque() {
    this.carregandoService.mostra('buscaProdutos');

    this.loteProdutoService.consultarPorIdProduto(this.produto.idProduto, this.idFornecedor).subscribe(dados => {
      this.lotes = dados;

      this.calcularTotal();

      this.carregandoService.esconde('buscaProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscaProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

  }

  async buscarVendaProgramada() {
    try {
      this.carregandoService.mostra('buscarVendaProgramada');
      this.vendaProgramada = (await this.premissasService.consultarVendaProgramada().toPromise()).valor;
      this.carregandoService.esconde('buscarVendaProgramada');
    } catch (erro) {
      this.carregandoService.esconde('buscarVendaProgramada');
      this.notificacaoService.erro(erro);
    }
  }

  mostrarPedidos(lote: LoteProduto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(PedidosLoteModalComponent, {
      width: largura > 1030 ? '1000px' : $('body').width().toString() + 'px',
      data: { tipo: 0, lote: lote.lote, produto: this.produto, idFornecedor: this.idFornecedor },
      panelClass: 'modal-card',
    });
  }

  calcularTotal() {
    if (this.lotes !== null && this.lotes !== undefined) {
      this.lotes.forEach(p => {
        this.totalQtd += p.qtEstoque;
        this.totalEstoque += p.estoqueAtual;
        this.totalReservado += p.qtReserva;
        this.totalFaturado += p.qtFaturado;
      });
    }
  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(f => {
      this.mostrarCodErp = f.valor;
      this.carregandoService.esconde('buscarMostrarCodErp');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarCodErp');
      this.notificacaoService.erro(erro);
    });
  }

  exportar() {

    this.carregandoService.mostra('exportarLotesDoProduto');
    this.loteProdutoService.exportarLotesDoProduto(this.produto.idProduto, this.idFornecedor).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'Lotes_do_produto.xlsx');
      this.carregandoService.esconde('exportarLotesDoProduto');
    }, (erro) => {
      this.carregandoService.esconde('exportarLotesDoProduto');
      this.notificacaoService.erro(erro);
    });

  }
}
